<div class="status-container">
  <div class="status-light" [style.background]="templateStatus | statusLightColor"></div>
  <div class="status-text">{{ templateStatus | titlecase }}</div>
</div>
